<template>
  <a-modal :title="viewTitle" visible @cancel="cancel">
    <ak-inputs :options="editFields" ref="inputs" v-model="data" />
    <template slot="footer">
      <a-button type="primary" @click="cancel">确定</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  name: 'viewPage',
  data () {
    return {
      data: null,
      details: {
        type: 'Object',
        items: [
          {
            name: 'name',
            note: '代金券名称',
            type: 'String',
            disabled: true
          },
          {
            name: 'shopType',
            note: '代金券类型',
            type: 'Select',
            disabled: true,
            items: {
              unconditional: '无条件',
              reduction: '满减'
            }
          },
          {
            name: 'total',
            note: '发放数量',
            disabled: true,
            type: 'Number'
          },
          {
            name: 'shopAmount',
            note: '使用金额',
            disabled: true,
            tooltip: '无条件类型，金额为0,，满减需要设置金额',
            type: 'Number'
          },
          {
            name: 'shopQuota',
            disabled: true,
            note: '抵扣金额',
            type: 'Number'
          }
        ]
      }
    }
  },
  computed: {
    editFields () {
      let data = this.model.fields.filter((field) => !field.hideOnEdit)
      let arr = []
      data.forEach((e) => {
        let obj = {}
        if (e.disabled) {
          obj = { ...e.schema, name: e.name, disabled: true }
        } else {
          obj = { ...e.schema, name: e.name, disabled: true }
        }
        if (e.name === 'details') {
          obj.items = this.details
        }
        arr.push(obj)
      })
      return arr
    }
  },
  async mounted () {
    this.data = this.$tkHelper.deepClone(this.record)
    // 查询代金券详情
    let { data: rs } = await this.$tkParse.get(`/classes/coupon`, {
      params: {
        where: {
          objectId: {
            $in: this.data.details
          }
        }
      }
    })
    this.data.details = rs.results
  },
  methods: {
    cancel () {
      this.$emit('complete', 'cancel')
    }
  },
  props: {
    record: Object, // 当前行的数据
    model: Object, // 当前model对象
    field: Object, // 当前field对象
    viewTitle: {
      type: String,
      default: '查看'
    }
  }
}
</script>

<style scoped>
</style>
